import { render, staticRenderFns } from "./GroupDetailSubmit.vue?vue&type=template&id=6d154d0c&scoped=true"
import script from "./GroupDetailSubmit.vue?vue&type=script&lang=js"
export * from "./GroupDetailSubmit.vue?vue&type=script&lang=js"
import style0 from "./GroupDetailSubmit.vue?vue&type=style&index=0&id=6d154d0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d154d0c",
  null
  
)

export default component.exports